import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { SideNavService } from 'src/app/core-flc/sidenav/sidenav.service';
import { RouterLinkEnum } from 'src/app/enums/router-link-enum';
import { GetRastersFiltered$Params } from 'src/app/server-api/fn/raster-controller/get-rasters-filtered';
import { RasterCatCode, RasterFilterDto } from 'src/app/server-api/models';
import { RasterControllerService } from 'src/app/server-api/services';
import { ListComponent } from 'src/app/utils-flc/list/list.component';



@Component({
  selector: 'app-rasters-list',
  templateUrl: './rasters-list.component.html',
  styleUrls: ['./rasters-list.component.css']
})
export class RastersListComponent extends ListComponent {

  rasterUpload: boolean;

  constructor(public override translate: TranslateService, public override sidenavService: SideNavService, private rasterService: RasterControllerService) {
      super(translate, sidenavService);

      this.constructorName = 'RastersList';
    }

  override ngOnInit(): void {

    this.placeholderSearchText = 'rasters.search';
    this.exportPrefix = 'rasters_';
    this.primarySort.active = 'category';
    this.defaultSort.active = 'category';
    this.profilesAllowEdit = 'ADMIN,UPLOADER';

    super.ngOnInit();
  }

  override initAfterRoutePath()
  {
    this.rasterUpload = (this.routePath.indexOf(RouterLinkEnum.RASTERS_UPLOAD_LIST.link.split('/')[1]) !== -1);

    this.translate
      .get(['rasters.button_create', 'icon_refresh', 'action_show', "raster.category-type"
    ])
      .subscribe((translations: string[]) => {
        this.translations = translations;
        this.topMenuIcons = [
            { icon: "add", title: translations['rasters.button_create'], routerLink: RouterLinkEnum.RASTERS_UPLOAD + "new", clickMethod: "dummy", checkDisable: true},
            { icon: "refresh", title: translations['icon_refresh'], routerLink: null, clickMethod: "refresh"}
          ];

        this.actions = [
          {icon: "playlist_add", title: translations['action_show'], routerLink: RouterLinkEnum.RASTERS_UPLOAD.toString(), clickMethod: "dummy"}
        ];

        if (this.rasterUpload)
        {
          this.displayedColumns = ['actions', 'category', 'lastModificationDate', 'originalFileName'];
          this.filterFields = [''];
        }
        else
        {
          this.displayedColumns = ['actions', 'category', 'modelCalculation', 'lastModificationDate'];
          this.filterFields = [''];

          //remove add topmenuIcon
          //set correct action link for detail
          this.topMenuIcons.splice(0, 1);
          this.actions[0].routerLink = RouterLinkEnum.RASTERS.toString();
        }
    });
  }

  override getItems() {
    super.getItems();

    let filterRequest: string = this.filter ? this.filter.nativeElement.value : '';
    let bodyRequest:RasterFilterDto = { temporary: this.rasterUpload };
    for (let filter of this.filters)
    {
       if (filter.field === '') filterRequest = filter.value;
       if (filter.field === this.translations['raster.category-type']) bodyRequest.categoryCode = this.getCategoryType(filter.value);
    }

    let request:GetRastersFiltered$Params = {
      page: this.paginator.pageIndex,
      size: this.paginator.pageSize,
      sort: [this.dataSource.sort.active + ',' + this.dataSource.sort.direction],
      filter: filterRequest,
      body: bodyRequest
    };
    this.rasterService.getRastersFiltered(request).subscribe(
      value  => {
        this.dataSource.data = value['content'];
        this.listIds = this.dataSource.data.map(d => d.id);

        this.totalElements = value['totalElements'];
        this.sidenavService.setLoading(false);
      }
    ,
      error => {
        console.error(JSON.stringify(error));
        this.sidenavService.setLoading(false);
      }
        ,
      () => {
       this.sidenavService.setLoading(false);
      }
    );
  }

  getCategoryType(code: string)
  {
    var keys = Object.keys(RasterCatCode);
    var result: RasterCatCode;

    keys.forEach((obj, index) => {
      if (code.toUpperCase() === obj.toUpperCase()) {
        result = RasterCatCode[obj];
      }
    });
    return result;
  }
}

